import { IonChip, useIonAlert } from "@ionic/react";
import { useTranslation } from 'react-i18next';

const BetaChip: React.FC = () => {
    const { t: tComponents } = useTranslation('components');
    const { t: tModals } = useTranslation('modals');
    const [presentAlert] = useIonAlert();

    const presentInfo = () => {
        presentAlert({
            header: tModals('beta_alert.header'),
            message: tModals('beta_alert.message'),
            buttons: [tModals('beta_alert.ok_button')]
        });
    }

    return (
        <IonChip color="warning" onClick={presentInfo}>
            {tComponents('beta_chip.beta')}
        </IonChip>
    );
};

export default BetaChip;